
import React from 'react';
import TreatmentPageTemplate from './TreatmentPageTemplate';

const Dermaplaning = () => {
  const treatmentData = {
    title: "Dermaplaning",
    subtitle: "Gentle exfoliation for smooth, radiant skin",
    description: "Dermaplaning is a gentle exfoliation technique that removes dead skin cells and fine facial hair, revealing smoother, brighter skin with improved product absorption.",
    whoItsFor: [
      "Those with rough or textured skin",
      "People wanting immediate skin smoothing",
      "Anyone with fine facial hair",
      "Clients preparing for special events",
      "Those wanting enhanced product absorption"
    ],
    packages: [
      {
        name: "Dermaplaning Treatment",
        visitorPrice: "$150",
        memberPrice: "$135",
        description: "Professional dermaplaning with moisturizing mask"
      },
      {
        name: "Dermaplaning + Facial",
        visitorPrice: "$250",
        memberPrice: "$225",
        description: "Dermaplaning combined with hydrating facial"
      },
      {
        name: "Monthly Series",
        visitorPrice: "$400",
        memberPrice: "$360",
        description: "Package of 3 treatments for ongoing maintenance"
      }
    ],
    beforeCare: [
      "Avoid retinoids 3 days prior",
      "No recent waxing or tweezing",
      "Come with clean, makeup-free skin",
      "Avoid sun exposure day of treatment"
    ],
    duringCare: [
      "Gentle cleansing and prep",
      "Precise dermaplaning technique",
      "30-45 minute treatment time",
      "Soothing mask application"
    ],
    afterCare: [
      "Apply SPF 30+ immediately",
      "Avoid harsh products for 24 hours",
      "Gentle skincare routine only",
      "Results visible immediately"
    ],
    memberPerks: [
      "10% discount on dermaplaning packages",
      "Complimentary post-treatment serum",
      "Priority booking for monthly maintenance",
      "Free skin consultation with each treatment",
      "Access to professional exfoliating products"
    ]
  };

  return <TreatmentPageTemplate {...treatmentData} />;
};

export default Dermaplaning;
